import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-accent-100/80 text-accent-700 text-xs font-semibold rounded-full mb-3">
            最新动态
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-foreground-950">
            平台快讯
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            实时追踪豆花视频最新片源上线、功能更新与活动公告
          </p>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-background-300/60 -translate-x-1/2"></div>

          <div className="flex flex-col gap-0">
            {updatesData.map((item, i) => (
              <div
                key={i}
                className={`relative flex flex-col md:flex-row items-start gap-4 md:gap-8 py-5 md:py-6 ${
                  i % 2 === 0
                    ? 'md:flex-row'
                    : 'md:flex-row-reverse'
                }`}
              >
                <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right md:pr-8' : 'md:text-left md:pl-8'} w-full`}>
                  <div className="md:hidden flex items-center gap-3 mb-2">
                    <div className="w-3 h-3 rounded-full bg-accent-500 shrink-0 relative z-10"></div>
                    <span className="text-xs text-foreground-400">{item.date}</span>
                  </div>

                  <div className="flex items-center gap-2 mb-1.5">
                    <div className="hidden md:block w-3 h-3 rounded-full bg-accent-500 absolute top-8 left-1/2 -translate-x-1/2 z-10"></div>
                    <span className={`hidden md:inline text-xs text-foreground-400 ${i % 2 === 0 ? 'md:order-1' : ''}`}>
                      {item.date}
                    </span>
                    <span className="inline-block px-2.5 py-0.5 bg-accent-100/70 text-accent-700 text-xs font-semibold rounded-full whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>

                  <h3 className="text-base md:text-lg font-bold text-foreground-900 leading-snug">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-sm text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>

                <div className="hidden md:block flex-1"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}